import {useNavigate} from 'react-router-dom';
import {motion} from 'framer-motion';
import Button from "../../../elements/Button/Button";
import styles from './ModalDelete.module.scss'
import {useDispatch, useSelector} from "react-redux";
import {closeModal} from "../../../../store/actions/modalActions";
import {deleteInvoice} from "../../../../store/actions/invoicesActions";

const ModalDelete = ({variants}) => {
    const dispatch = useDispatch();
    const invoice = useSelector((state) => state.invoices.currentInvoice);
    const navigate = useNavigate();

    const routeChange = () => {
        navigate('/');
    };

    const handleDelete = () => {
        dispatch(deleteInvoice(invoice.id));
        dispatch(closeModal());
        routeChange();
    }

    return (
        <motion.div className={styles.container} variants={variants}>
            <h2>Confirm Deletion</h2>
            <p className={styles.modalText}>
                Are you sure you want to delete invoice #
                {invoice.number}? This action cannot be undone.
            </p>
            <div className={styles.ctaGroup}>
                <Button type="button" className='tertiary' onClick={() => dispatch(closeModal())}>
                    Cancel
                </Button>
                <Button
                    type="button"
                    className='delete'
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </div>
        </motion.div>
    );
};

export default ModalDelete;
